import * as Sebrae from '@sebrae/react-core';
import React, { useEffect, useState } from 'react';
import { useModuleController } from '../../../../hooks/controllers/module-public-controller';
import { LayoutFooterCandidate } from '../../components/layout-candidate/footer-candidate/footer-candidate';
import { AlignText, Aside, Background, Content } from './link-expirado-styled';

import { BaSeParagraph, BaSeTheme } from '@base/react';
import graphHome from '../../../manager/assets/empreenda.png';
import bannerEmpretec from '../../assets/banner-empretec.png';

const cache = Sebrae.StorageUtil.inTemporaryStore();

export const LinkExpirado = () => {
  const [module, setModule] = useState(1);
  const [dataSettings, setDataSettings] = useState({});
  const { getSettingsModule } = useModuleController();

  useEffect(() => {
    const modulo = cache.getItem('@empretec:module');
    setModule(modulo);

    getSettingsModule(Number(modulo))
      .then((settings) => {
        setDataSettings(settings.settingsMap);
      })
      .catch((err) => console.log(err));
  }, [getSettingsModule]);
  return (
    <Background module={module}>
      <Content>
        <img src={dataSettings.empretecManagerActor} alt="" />
        <Aside>
          <img src={graphHome} alt="" width={233} height={306} />
          <AlignText>
            <BaSeParagraph isBold color={BaSeTheme.colors.defaultColors.white}>
              Link expirado.
            </BaSeParagraph>

            <BaSeParagraph color={BaSeTheme.colors.defaultColors.white}>
              O candidato já realizou o seminário do Empretec!
            </BaSeParagraph>
          </AlignText>
          <img src={bannerEmpretec} alt="" />
        </Aside>
      </Content>
      <LayoutFooterCandidate />
    </Background>
  );
};
